import request from '@/utils/request'

// 分页查询工单交接监控明细
export function apiGetInvHandoverMonitorDetailPage (data) {
  return request({
    url: '/inv/invHandoverMonitorDetail/page',
    method: 'post',
    data: data
  })
}

// 导出工单交接监控明细
export function apiInvHandoverMonitorDetailExport (data) {
  return request({
    url: '/inv//invHandoverMonitorDetail/export',
    method: 'post',
    data: data
  })
}
